<template>
    <a class="e-btn-app-store" :href='href' :title="title" target="_blank" style="vertical-align: middle; position: relative;">
            <img :height="height" :alt="title" :src="imgSrc"/>
    </a>
</template>

<script>

import {isFrench} from "@/../vue-components/helpers/i18n";

export default {
    name: `e-btn-app-store`,
    props: {
        href: {type: String, required: true},
        store: {type: String, default: `app-store`}, // app-store|google-play
        height: {type: [String, Number], default: 50}
    },
    data() {
        return {
            isFrench
        }
    },
    computed: {
        title() {
            switch (this.store) {
                case `app-store`:
                    return this.tr(`Download on the App Store|Télécharger sur l'App Store`);
                case `google-play`:
                    return this.tr(`Download on Google Play|Télécharger sur Google Play`);
                default:
                    return this.store;
            }
        },
        imgSrc() {
            switch (this.store) {
                case `app-store`:
                    return this.tr(`https://eyeinlivestorage.blob.core.windows.net/public/icons/badges/app-store-en.svg|https://eyeinlivestorage.blob.core.windows.net/public/icons/badges/app-store-fr.svg`);
                case `google-play`:
                    return this.tr(`https://eyeinlivestorage.blob.core.windows.net/public/icons/badges/google-play-en.png|https://eyeinlivestorage.blob.core.windows.net/public/icons/badges/google-play-fr.png`);
                default:
                    return this.store;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.e-btn-app-store {
    vertical-align: middle;
    position: relative;
}
</style>
